export default "__VITE_ASSET__C6Cy0ocH__"